import { useLayoutEffect, useEffect, useState } from "react";
import { SERVER_URL } from "../../util/url";

import "./orderslist.css";

function Orderslist(props) {
    const [workOrders, setWorkOrders] = useState([]);
    let [displayWorkOrders, setDisplayWorkOrders] = useState([]);
    let [numberTableElement, setNumberElement] = useState(5);
    let [offsetTablePage, setOffsetTablePage] = useState(0);
    const tableIndex = [5, 10, 15, 20, 25, 30];
    const [filters, setFilters] = useState([]);
    const [productFilter, setProductFilter] = useState("");
    const [machineFilter, setMachineFilter] = useState("");

    const initializedFilters = () => {
        filters.length = 0;
        if (props.parameters === "executionorders") {
            filters.push("Ordini in esecuzione");
            setFilters([...filters]);
        } else if (props.parameters === "last30daysorders") {
            filters.push("ODL finiti negli ultimi 30 giorni");
            setFilters([...filters]);
        }
    };

    const fetchWorkOrders = async (signal) => {
        workOrders.length = 0;
        displayWorkOrders.length = 0;
        let api = SERVER_URL + "/workorders?plant=" + props.plant;

        if (filters.length !== 0 && filters[0] === "Ordini in esecuzione") {
            api += "&status=RUNNING";
        } else if (filters.length !== 0 && filters[0] === "ODL finiti negli ultimi 30 giorni") {
            api = SERVER_URL + "/workorders/woendedlast30days?plant=" + props.plant + "&display=true";
        }

        let newListWorkOrders = [];
        await fetch(api, { signal })
            .then((res) => res.json())
            .then((data) => {
                newListWorkOrders = data.data;
            })
            .catch((err) => {
                if (err.name === "AbortError") {
                    console.log("request aborted");
                } else {
                    console.log(err);
                }
            });

        setWorkOrders([...newListWorkOrders]);
    };

    const handleClickCloseFilters = (index) => {
        if (index === "filter_0") props.setOrderParameters("");
        filters.splice(index.substring(7), 1);
        setFilters([...filters]);
        fetchWorkOrders();
    };

    useLayoutEffect(() => {
        const controller = new AbortController();
        const signal = controller.signal;

        initializedFilters();
        fetchWorkOrders(signal);

        return () => {
            controller.abort();
        };
    }, [props.plant]);

    useEffect(() => {
        displayWorkOrders = [];
        if (workOrders.length !== 0) {
            for (let i = offsetTablePage; i < numberTableElement && workOrders[i]; i++) {
                displayWorkOrders.push(workOrders[i]);
            }
            setDisplayWorkOrders([...displayWorkOrders]);
        }

        return () => {};
    }, [workOrders]);

    function changeWorkOrders() {
        displayWorkOrders = [];
        if (workOrders.length !== 0) {
            for (let i = offsetTablePage; i < offsetTablePage + numberTableElement && i < workOrders.length; i++) {
                displayWorkOrders.push(workOrders[i]);
            }
            setDisplayWorkOrders([...displayWorkOrders]);
        }
    }

    function changeNumberTableElement(index) {
        numberTableElement = index;
        offsetTablePage = 0;
        changeWorkOrders();
        setNumberElement(index);
        setOffsetTablePage(0);
    }

    function incrementOffsetTablePage() {
        if (offsetTablePage + numberTableElement < workOrders.length) {
            offsetTablePage += numberTableElement;
            changeWorkOrders();
            setOffsetTablePage(offsetTablePage);
        }
    }

    function decrementOffsetTablePage() {
        if (offsetTablePage - numberTableElement >= 0) {
            offsetTablePage -= numberTableElement;
            changeWorkOrders();
            setOffsetTablePage(offsetTablePage);
        } else {
            offsetTablePage = 0;
            changeWorkOrders();
            setOffsetTablePage(0);
        }
    }

    function formatIndexTables() {
        if (workOrders.length < numberTableElement) {
            return <p className="index-table my-auto"> 1-{workOrders.length} of 1 </p>;
        } else {
            return (
                <p className="index-table my-auto">
                    {" "}
                    1-{displayWorkOrders.length} of {Math.ceil(workOrders.length / numberTableElement)}
                </p>
            );
        }
    }

    function formatStatus(status) {
        if (status === "STARTING") {
            return (
                <span className="badge" style={{ backgroundColor: "#00cc00" }}>
                    {status}
                </span>
            );
        } else if (status === "RUNNING") {
            return (
                <span className="badge" style={{ backgroundColor: "#ff9900" }}>
                    {status}
                </span>
            );
        } else {
            return (
                <span className="badge" style={{ backgroundColor: "#cc0000" }}>
                    {status}
                </span>
            );
        }
    }

    return (
        <div className="orderslist p-4 bg-light">
            <div className="d-flex mb-3">
                <p className="fs-5 my-auto"> Filtri: </p>
                {filters.length !== 0 ? (
                    filters.map((filter, index) => {
                        return (
                            <div className="d-flex mx-3 py-1 px-2 border" style={{ borderRadius: "5px" }} key={"filter_" + index}>
                                <button type="button" id={"filter_" + index} className="btn-close" aria-label="Close" onClick={(e) => handleClickCloseFilters(e.currentTarget.id)}></button>
                                <p className="mx-2 m-0"> {filter} </p>
                            </div>
                        );
                    })
                ) : (
                    <div className="d-flex mx-3 py-1 px-2 border" style={{ borderRadius: "5px" }}>
                        <p className="mx-2 m-0"> Nessun filtro </p>
                    </div>
                )}
                <div className="d-flex mx-3">
                    <p className="m-0 my-auto mx-2"> Articolo: </p>
                    <div className="my-auto">
                        <input type="text" placeholder="Filtra per articolo" onChange={(e) => setProductFilter(e.currentTarget.value)} />
                    </div>
                </div>
                <div className="d-flex mx-3">
                    <p className="m-0 my-auto mx-2"> Pressa: </p>
                    <div className="my-auto">
                        <input type="text" placeholder="Filtra per pressa" onChange={(e) => setMachineFilter(e.currentTarget.value)} />
                    </div>
                </div>
            </div>
            <div className="card">
                <div className="table-responsive">
                    <table className="table table-hover m-0">
                        <thead className="table-light">
                            <tr>
                                <th scope="col" className="p-1">
                                    <div className="d-flex">
                                        &ensp;
                                        <span className="material-symbols-outlined table-header-icon">calendar_today</span>
                                        &ensp;
                                        <p className="table-header m-0">AVVIO</p>
                                    </div>
                                </th>
                                <th scope="col" className="p-1">
                                    <div className="d-flex">
                                        &ensp;
                                        <span className="material-symbols-outlined table-header-icon">search</span>
                                        &ensp;
                                        <p className="table-header m-0">STAMPO</p>
                                    </div>
                                </th>
                                <th scope="col" className="p-1">
                                    <div className="d-flex">
                                        &ensp;
                                        <span className="material-symbols-outlined table-header-icon">search</span>
                                        &ensp;
                                        <p className="table-header m-0">ARTICOLO</p>
                                    </div>
                                </th>
                                <th scope="col" className="p-1">
                                    <div className="d-flex">
                                        &ensp;
                                        <span className="material-symbols-outlined table-header-icon">search</span>
                                        &ensp;
                                        <p className="table-header m-0">PRESSA</p>
                                    </div>
                                </th>
                                <th scope="col" className="p-1" style={{ minWidth: "175px" }}>
                                    <div className="d-flex">
                                        &ensp;
                                        <span className="material-symbols-outlined table-header-icon">search</span>
                                        &ensp;
                                        <p className="table-header m-0">ORDINE DI LAVORO</p>
                                    </div>
                                </th>
                                <th scope="col" className="p-1">
                                    <div className="d-flex">
                                        &ensp;
                                        <span className="material-symbols-outlined table-header-icon">filter_list</span>
                                        &ensp;
                                        <p className="table-header m-0">STATUS</p>
                                    </div>
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            {displayWorkOrders.length === 0 && (
                                <tr>
                                    <td colSpan={6} className="text-center">
                                        <p className="m-0 fst-italic"> Non sono presenti Ordini di lavoro</p>
                                    </td>
                                </tr>
                            )}
                            {displayWorkOrders.map((element) => {
                                if (productFilter !== "" && !element["prod"].toLowerCase().includes(productFilter.toLowerCase())) return null;
                                if (machineFilter !== "" && !element["machine"].toLowerCase().includes(machineFilter.toLowerCase())) return null;
                                return (
                                    <tr key={element.id}>
                                        <td>
                                            {element["start_date"] ? element["start_date"] : ""} <br /> {element["stop_date"] ? element["stop_date"] : ""}
                                        </td>
                                        <td className="align-middle">{element["mould"]}</td>
                                        <td className="align-middle">{element["prod"]}</td>
                                        <td className="align-middle">{element["machine"]}</td>
                                        <td className="align-middle">{element.id}</td>
                                        <td className="align-middle">{formatStatus(element["status"])}</td>
                                    </tr>
                                );
                            })}
                        </tbody>
                    </table>
                </div>
                <div className="p-2">
                    <div className="d-flex justify-content-between">
                        <div className="d-flex">
                            <p className="my-auto">Risultati per pagina</p>
                            &ensp;&ensp;
                            <div className="dropdown">
                                <button className="btn border dropdown-toggle p-1" type="button" data-bs-toggle="dropdown" aria-expanded="false">
                                    {numberTableElement}&ensp;&ensp;&ensp;
                                </button>
                                <ul className="dropdown-menu">
                                    {tableIndex.map((number, index) => {
                                        if (number !== numberTableElement) {
                                            return (
                                                <li key={index}>
                                                    <a className="dropdown-item" onClick={() => changeNumberTableElement(number)}>
                                                        {number}&ensp;&ensp;&ensp;
                                                    </a>
                                                </li>
                                            );
                                        }
                                    })}
                                </ul>
                            </div>
                        </div>
                        <div className="d-flex">
                            {formatIndexTables()}
                            <button className="btn mt-1 p-0" onClick={() => decrementOffsetTablePage()}>
                                <span className="material-symbols-outlined">chevron_left</span>
                            </button>
                            <button className="btn mt-1 p-0" onClick={() => incrementOffsetTablePage()}>
                                <span className="material-symbols-outlined">navigate_next</span>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Orderslist;
